import { useState } from "react";
import {
  GoabBlock,
  GoabContainer,
  GoabFormItem,
  GoabInput,
  GoabSpacer,
} from "@abgov/react-components";

import { useGenerationForm, useSessionManagement } from "../../hooks";

import { formatPhoneNumber } from "../../../../../MPP-Common-SPA/utils/globalUtility";

export const PrimaryContactInformationSection = () => {
  const {
    form,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handlePrimaryContactInfoChange,
    handleBlur,
    isReady,
  } = useGenerationForm("PersonalInformation");

  const { getResourceValue } = useSessionManagement();

  const [mobileInputKey, setMobileInputKey] = useState(0);
  const [phoneInputKey, setPhoneInputKey] = useState(0);

  if (!isReady) return <></>;

  const mobileError = fieldErrors.mobile && fieldTouches.mobile;
  const phoneError = fieldErrors.phone && fieldTouches.phone;
  const isInputValid =
    !fieldValues.phone &&
    !fieldValues.mobile &&
    (fieldTouches.mobile || fieldTouches.phone);

  return (
    <>
      <GoabContainer accent="thin">
        <h3>
          {getResourceValue({
            key: "RESOURCES@personalInformation.accentContainer.title",
          })}
        </h3>
        <GoabSpacer vSpacing="m" />
        <GoabBlock direction="row" gap="l">
          <GoabFormItem
            label={getResourceValue({ key: "RESOURCES@form.mobile.label" })}
            error={fieldErrors.mobile}
          >
            <GoabInput
              key={`mobile-${mobileInputKey}`}
              name="mobile"
              type="text"
              value={fieldValues.mobile}
              onChange={({name, value}) => {
                const number = formatPhoneNumber(value);
                if (number !== value && number.length >= 10) {
                  setMobileInputKey((inputKey) => inputKey + 1);
                  setTimeout(() => form.validateForm());
                }
                handlePrimaryContactInfoChange(name, number);
              }}
              onBlur={({name, value}) => handleBlur(name)}
              error={!!mobileError}
            />
          </GoabFormItem>
          <GoabFormItem
            label={getResourceValue({ key: "RESOURCES@form.phone.label" })}
            error={fieldErrors.phone}
          >
            <GoabInput
              key={`phone-${phoneInputKey}`}
              name="phone"
              type="text"
              value={fieldValues.phone}
              onChange={({name, value}) => {
                const number = formatPhoneNumber(value);
                if (number !== value && number.length >= 10) {
                  setPhoneInputKey((inputKey) => inputKey + 1);
                  setTimeout(() => form.validateForm());
                }
                handlePrimaryContactInfoChange(name, number);
              }}
              onBlur={({name, value}) => handleBlur(name)}
              error={!!phoneError || !!isInputValid}
            />
          </GoabFormItem>
        </GoabBlock>
      </GoabContainer>
    </>
  );
};
